/**
 * Lightweight module-level store for the active profile ID.
 * Used by the apiClient interceptor to inject X-Profile-ID headers
 * without creating circular dependencies with ProfileContext.
 */

const STORAGE_KEY = 'cg_active_profile_id';

let _activeProfileId: string | null = null;

export function setActiveProfileId(id: string | null): void {
  _activeProfileId = id;
  if (id) {
    try { localStorage.setItem(STORAGE_KEY, id); } catch {}
  } else {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  }
}

export function getActiveProfileId(): string | null {
  if (_activeProfileId) return _activeProfileId;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      _activeProfileId = stored;
      return stored;
    }
  } catch {}
  return null;
}
